/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PendingInputs */

const en_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

const fr_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const es_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const it_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In attesa`)
};

const nl_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In afwachting`)
};

const pl_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oczekujące`)
};

const fi_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odottaa`)
};

const da_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venter`)
};

const sv_common_pending = /** @type {(inputs: Common_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendande`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Common_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_pending = /** @type {((inputs?: Common_PendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_pending(inputs)
	if (locale === "fr") return fr_common_pending(inputs)
	if (locale === "es") return es_common_pending(inputs)
	if (locale === "it") return it_common_pending(inputs)
	if (locale === "nl") return nl_common_pending(inputs)
	if (locale === "pl") return pl_common_pending(inputs)
	if (locale === "fi") return fi_common_pending(inputs)
	if (locale === "da") return da_common_pending(inputs)
	if (locale === "sv") return sv_common_pending(inputs)
	return en_common_pending(inputs)
});